import type { RouteHandlerResult } from '@shared/types/backend/page-route';
import type { MetaDescriptor } from 'react-router';

export const metaProvider = <T extends RouteHandlerResult>({
  data: loaderData,
}: {
  data: T;
}): MetaDescriptor[] => {
  const metaTags: MetaDescriptor[] = [
    {
      title: loaderData.pageData.title,
    },
  ];

  if ('description' in loaderData.pageData) {
    metaTags.push({
      name: 'description',
      content: loaderData.pageData.description,
      tagName: 'meta',
    });
  }

  return metaTags;
};
